import { HOST_QUERY_KEY, iamApiInstance } from '@kc-console/context';
import { STATUS_CODE } from '@kc-console/core';

import { commonGuardErrorHandler } from '../../utils/commonGuardErrorHandler';

import type { ServiceAppState } from '@kc-console/context';
import type { Guard } from '../../types';

export const determineDomainDetailInfoGuard: Guard<ServiceAppState> = async ({
  state,
  queryClient,
  context,
}) => {
  const { token, domainId } = state;
  const { fetchDomainDetailInfo } = iamApiInstance({ token });

  // token이나 domainId가 없으면 도메인 상세 정보를 가져올 수 없으므로, 그냥 통과시킨다.
  if (!token || !domainId) return { status: STATUS_CODE.OK };

  try {
    await queryClient.fetchQuery({
      queryKey: [HOST_QUERY_KEY.GET_IAM_DOMAIN_DETAIL_INFO, { domainId }],
      queryFn: () => fetchDomainDetailInfo({ domainId }),
    });

    return { status: STATUS_CODE.OK };
  } catch (error) {
    return commonGuardErrorHandler({ error, context, state });
  }
};

determineDomainDetailInfoGuard.displayName = 'determineDomainDetailInfoGuard';
